(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.ukhighschool === "undefined") {
        jQuery.extend(sm.portal.vm, { ukhighschool: {} });
    }

    function AnythingPopulated(dataItem){
        // highschool selected from list or manually defined?
        if (dataItem.HighSchoolID() > 0 || (dataItem.HighSchoolID() == 0 && !sm.portal.utility.isNullOrEmpty(dataItem.HighSchoolName()))) return true;
        if (!sm.portal.utility.isNullOrEmpty(dataItem.SchoolCity())) return true;
        if (!sm.portal.utility.isNullOrEmpty(dataItem.SchoolCountryID())) return true;
        if (!sm.portal.utility.isNullOrEmpty(dataItem.SchoolCountry())) return true;
        
        return false;
    }

    function SaveWorkingChangesSetupWI(highSchool, workingItem){

        workingItem.SchoolCity = highSchool.WorkingItem().SchoolCity;
        workingItem.SchoolCountryID = highSchool.WorkingItem().SchoolCountryID;
        
        if(workingItem.SchoolCountryID){
            workingItem.SchoolCountry(highSchool.GetCountryNameById(workingItem.SchoolCountryID).name);
        } else {
            workingItem.SchoolCountry = highSchool.WorkingItem().SchoolCountry;
        }

        workingItem.enableSchoolAddressFields = ko.observable(false);
    }

    function SaveWorkingChangesWIEdit(highSchool, workingItem){
        highSchool.OriginalItem().SchoolCity(workingItem.SchoolCity);
        highSchool.OriginalItem().SchoolCountryID(workingItem.SchoolCountryID);
        highSchool.OriginalItem().SchoolCountry(workingItem.SchoolCountry);
    }

    function EditItem(highschool, data){
        highschool.WorkingItem(
            new sm.portal.vm.HighSchoolDataItem(
                JSON.parse(ko.toJSON(data))
            )
        );
        highschool.WorkingItem.valueHasMutated();
    }

    function LoadModelPreDataItem(currentHighSchool) {
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        var mdyDateFormat = "MM/DD/YYYY";
        var ymdDateFormat = "YYYY-MM-DDTHH:mm:ss";

        if (currentHighSchool.StartDate != null && currentHighSchool.StartDate != undefined && currentHighSchool.StartDate.length > 0) {
            if (currentHighSchool.StartDate.charAt(1) === '/' || currentHighSchool.StartDate.charAt(2) === '/') {
                currentHighSchool.StartDate = moment(currentHighSchool.StartDate, mdyDateFormat).format(dateFormat);
            } else {
                currentHighSchool.StartDate = moment(currentHighSchool.StartDate, ymdDateFormat).format(dateFormat);
            }
        }
        if (currentHighSchool.EndDate != null && currentHighSchool.EndDate != undefined && currentHighSchool.EndDate.length > 0) {
            if (currentHighSchool.EndDate.charAt(1) === '/' || currentHighSchool.EndDate.charAt(2) === '/') {
                currentHighSchool.EndDate = moment(currentHighSchool.EndDate, mdyDateFormat).format(dateFormat);
            } else {
                currentHighSchool.EndDate = moment(currentHighSchool.EndDate, ymdDateFormat).format(dateFormat);
            }
        }
        if (currentHighSchool.GraduationDate != null && currentHighSchool.GraduationDate != undefined && currentHighSchool.GraduationDate.length > 0) {
            if (currentHighSchool.GraduationDate.charAt(1) === '/' || currentHighSchool.GraduationDate.charAt(2) === '/') {
                currentHighSchool.GraduationDate = moment(currentHighSchool.GraduationDate, mdyDateFormat).format(dateFormat);
            } else {
                currentHighSchool.GraduationDate = moment(currentHighSchool.GraduationDate, ymdDateFormat).format(dateFormat);
            }
        }
    }


    function LoadModel(currentHighSchool, dataItem, payload) {
        //If the HighSchoolAddressInformation object exists, loop through it, find the info that matches  the currentHighSchool
        //And assign the address data
        if (payload.HighSchoolAddressInformation != null && payload.HighSchoolAddressInformation.length > 0) {

            var highSchoolAddressInfo = null;
            for (var i = 0; i < payload.HighSchoolAddressInformation.length; i++) {
                if (payload.HighSchoolAddressInformation[i].SchoolID === currentHighSchool.HighSchoolID) {
                    highSchoolAddressInfo = payload.HighSchoolAddressInformation[i];

                    dataItem.SchoolCity = ko.observable(highSchoolAddressInfo.SchoolCity);
                    dataItem.SchoolCountryID = ko.observable(highSchoolAddressInfo.SchoolCountryID);
                    dataItem.SchoolCountry = ko.observable(highSchoolAddressInfo.SchoolCountry);

                    break;
                }  
            }

        }
        else
        {
            dataItem.SchoolCity = ko.observable(currentHighSchool.SchoolCity);
            dataItem.SchoolCountryID = ko.observable(currentHighSchool.SchoolCountryID);
            dataItem.SchoolCountry = ko.observable(currentHighSchool.SchoolCountry);
        }
    }

    function LoadListData(highSchoolVM, container){
        if(container.Payload.ListData){
            highSchoolVM.Countries = smapi.access.loadListItemModels(container.Payload.ListData.Countries, highSchoolVM.Countries);
        }
    }
    function Subscribe(highSchool, newValue){
        highSchool.enableSchoolAddressFields(newValue === 0);
        if (newValue > 0) {
            highSchool.LoadAddressFields(newValue);
        }

        highSchool.HighSchoolName.subscribe(function () {
            // ensure highschool id is zero'd on manual change
            highSchool.HighSchoolID(0);
        }, highSchool);
    }

    function HighSchoolDataItem(highSchoolDataItem){
        highSchoolDataItem.HighSchoolName.subscribe(function () {
            // ensure highschool id is zero'd on manual change
            highSchoolDataItem.HighSchoolID(0);
        }, highSchoolDataItem);

        highSchoolDataItem.LoadAddressFields = function (id) {

            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/gethighschoolmailingaddress?highschoolID={0}', id);
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    highSchoolDataItem.SchoolCity(data.Payload.HighSchoolAddress.SchoolCity);
                    highSchoolDataItem.SchoolCountryID(data.Payload.HighSchoolAddress.SchoolCountryID);
                }
            });
        };
    }

    function ExtractATO(highSchoolVM, stdHighSchoolInformationModel){

        stdHighSchoolInformationModel.SchoolCity = highSchoolVM.SchoolCity;
        stdHighSchoolInformationModel.SchoolCountryID = highSchoolVM.SchoolCountryID;

    }

    jQuery.extend(true, sm.portal.vm.ukhighschool, {
        AnythingPopulated: AnythingPopulated,
        SaveWorkingChangesSetupWI: SaveWorkingChangesSetupWI,
        SaveWorkingChangesWIEdit: SaveWorkingChangesWIEdit,
        EditItem: EditItem,
        LoadModel: LoadModel,
        LoadListData: LoadListData,
        Subscribe: Subscribe,
        HighSchoolDataItem: HighSchoolDataItem,
        ExtractATO: ExtractATO,
        LoadModelPreDataItem: LoadModelPreDataItem
    });

})(jQuery);